import { render, staticRenderFns } from "./EditorWindow.vue?vue&type=template&id=fa62f3f4&"
import script from "./EditorWindow.vue?vue&type=script&lang=ts&"
export * from "./EditorWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports